import { type Action, FilterActionTypes, action } from "easy-peasy";

import DEFAULT_TAG_IDS from "./default";
import { type LogEffect, createLogEffect } from "../../utils/store";

const logEffect = (property: keyof FilterActionTypes<TagIdsModel>) =>
  createLogEffect<TagIdsModel>("TAG_IDS", property, false);

export type TagIdsModel = {
  value: number[];
  valueOnChange: LogEffect<TagIdsModel>;
  set: Action<TagIdsModel, number[]>;
};

const tagIdsModel: TagIdsModel = {
  value: DEFAULT_TAG_IDS,
  valueOnChange: logEffect("value"),
  set: action((state, payload) => {
    const tagsChanged = state.value.join() !== payload.join();

    if (tagsChanged) {
      state.value = payload;
    }
  }),
};

export default tagIdsModel;
